import React,{useRef,useEffect,useState,useCallback} from 'react';
import CloseIcon from '@mui/icons-material/Close';  
import ForDeliveriesInformation from './ForDeliveriesInformation'; 
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import SearchIcon from '@mui/icons-material/Search';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { createTheme } from "@mui/material";
import CssBaseline from '@mui/material/CssBaseline';
import AppBar from '@mui/material/AppBar';
import MenuIcon from '@mui/icons-material/Menu';
import { alpha } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import axios from 'axios'
import LinearProgress from '@mui/material/LinearProgress';
import { format,parseISO } from 'date-fns'
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import MobileDatePicker from '@mui/lab/MobileDatePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import EventIcon from '@mui/icons-material/Event';
import InputAdornment from '@mui/material/InputAdornment';
import Button from '@mui/material/Button';;


const drawerWidth = 300;

const materialTheme = createTheme(({
  // set default for now
 
}));

const useStyles = makeStyles((theme) => ({
   appBar: {
      [theme.breakpoints.up('sm')]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
      },
    },
    menuButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        display: 'none',
      },
    },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
    roota: {
        ...theme.typography.button,
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(1),
      },
  },
  flexGrow: {
    flexGrow: 1, // This pushes the menu to the right
  },

  paper: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(1),
      width: '100%',
      padding:'.2rem'
    },
  },
}));
const filter = createFilterOptions();

export default function ForDeliveries(props){

  const defaultStartingDate = new Date();
  defaultStartingDate.setMonth(defaultStartingDate.getMonth() -1); // For subtract use minus (-)

  const classes = useStyles();
  const [isLoading,setIsLoading] = useState(true)
  const accountsElement = useRef();

  const [searchAccountTerm, setSearchAccountTerm] = useState({name:""});
  const [autoCompleteSearchOptionMessage,setAutoCompleteSearchOptionMessage] = useState("Searching...")
  const [loadSalesOrder,setLoadSalesOrder] = useState(true)
  const [autoSuggestAccounts, setAutoSuggestAccounts] = useState([]);
  const [searchByAnchorElement, setSearchByAnchorElement] = React.useState(null);
  const [openBreakdown, setOpenBreakdown] = useState(false);
  const [startingFilterDate,setStartingFilterDate] = React.useState(new Date());
  const [endingFilterDate,setEndingFilterDate] = useState(new Date())
  const [salesOrders,setSalesOrders] = useState([])
  const [accounts,setAccounts] = useState([])
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const openMenu = Boolean(menuAnchorEl);
  const [openDateFilterDialog,setOpenDateFilterDialog] = useState(false)
  const [openStartingDateCalendar, setOpenStartingDateCalendar] = useState(false)
  
  const [endingDate, setEndingDate] = React.useState(new Date());
  const [startingDate, setStartingDate] =  React.useState(new Date());
  const [openEndingDateCalendar, setOpenEndingDateCalendar] = useState(false)

  const [selectedSalesOrder, setSelectedSalesOrder] = useState(null)
  const [orderInfoAnchorElement,setOrderInfoAnchorElement] = useState(null)
  const [openOrdersInfoDialog, setOpenOrdersInfoDialog] = useState(false);
  const [showMessageDialog,setShowMessageDialog] = useState(false)
  const [messageDialogMessage,setMessageDialogMessage] = useState("")
    useEffect(()=>{
      
      // if(!loadSalesOrder){
      //   return
      // }
      
      fetchAccountForAutoSuggest(searchAccountTerm.name)
    },[searchAccountTerm])

    function fetchAccountForAutoSuggest(searchTerm){
      setAutoCompleteSearchOptionMessage("Searching...")
      const options = {
        method: 'POST',
        url: '/SellerAccounts/getSellerAccountsForAutoSuggest.json',
        data:objectToFormData({search_term:searchTerm})
      }
       axios(options)
         .then(res => {
  
         
          const isSuccess = res.data.response.is_success

          if(!isSuccess){
            alert("Error encounter")
            return;
          }
          const suggestedAccounts = res.data.response.seller_accounts
          if(suggestedAccounts.length <=0){
            setAutoCompleteSearchOptionMessage("No record found")
          }
       
          setAutoSuggestAccounts(suggestedAccounts)
         }).catch(error => {
            alert("Error encounter")
         })

  }

  useEffect(() => {

    if (!loadSalesOrder) {
      return false;
    }

    fetchAccountOrders(searchAccountTerm.name)

  }, [loadSalesOrder])
  
  function fetchAccountOrders(searchTerm){
    setLoadSalesOrder(false)
    setIsLoading(true)
    const options = {
      method: 'POST',
      url: '/TransactiSellerSalesOrder/getUserAssignedDeliveries.json',
      data:objectToFormData({
        search_term:searchTerm,
        start_date:format(startingFilterDate, 'yyyy-MM-dd'),
        end_date:format(endingFilterDate, 'yyyy-MM-dd'),
      })
    }
     axios(options)
       .then(res => {

        setIsLoading(false)
        setSalesOrders(res.data.response.SalesOrders)
        
       }).catch(error => {

        setIsLoading(false)
          alert("Error encounter")
         console.log(error)

       })

  }
  
  const objectToFormData = (object) => Object.keys(object).reduce((formData, key) => {
    formData.append(key, object[key]);
    
    return formData;
  }, new FormData());
  
  const searchByBtnHandleClick = (event) => {
    setSearchByAnchorElement(event.currentTarget);
  };
  
  function search(){
    return (
      <div position="static" style={{border:".1rem solid #989898",borderRadius:"4px",margin:'2px'}}>
          <Toolbar variant="dense" style={{padding:'0'}}>
              <Box flexGrow={1}>{autoComplete()}</Box>
              <Box>
              <IconButton className={classes.margin} size="large"  
              onClick={
                ()=>{
                  fetchAccountOrders(searchAccountTerm.name)
                }
              }>
              <SearchIcon/>
              </IconButton>
              </Box>
              <Box>
              <IconButton className={classes.margin} size="large" onClick={searchByBtnHandleClick}>
                <MoreVertIcon />
              </IconButton>
            </Box>
            {searchByDropdownMenu()}
          </Toolbar>
      </div>
    );
  }
  
  
  function autoComplete() {
    return (
      <Autocomplete
        value={searchAccountTerm.name}
        noOptionsText={autoCompleteSearchOptionMessage}
        onChange={(event, newValue) => {
          if (newValue === null || newValue.name === "") {
            setSearchAccountTerm({ name: "" }); // Use the state setter to update the state
            setLoadSalesOrder(true);
            return;
          }
          setSearchAccountTerm({ name: newValue.name });
          setLoadSalesOrder(true);
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        options={autoSuggestAccounts}
        isOptionEqualToValue={() => true}
        getOptionLabel={(option) => {
          if (typeof option === 'string') {
            return option;
          }
          if (option.inputValue) {
            return option.inputValue;
          }
          if (option.name) {
            return option.name;
          }
          return '';
        }}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.name + option.id}>
              {option.name}
            </li>
          );
        }}
        style={{ width: '100%', paddingLeft: '8px', outline: 'none' }}
        renderInput={(params) => (
          <TextField
            style={{ background: "white" }}
            variant='standard'
            {...params}
            InputProps={{ ...params.InputProps, disableUnderline: true }}
            onChange={(event)=>{
              setSearchAccountTerm({name:event.target.value})
            
            }}
          />
        )}
      />
    );
  }
       
  function salesOrderElement(salesOrder){
      return(<div>
        <Typography variant="h6" gutterBottom>
            {salesOrder.account_name}
        </Typography>
        <Typography gutterBottom variant="subtitle1">
            Address : {salesOrder.Account.address}  <br/> 
            P.O # : {salesOrder.po_number}<br/>
            P.O date : {formatDate(salesOrder.po_datetime)}<br/>
            Invoice date : {salesOrder.invoice_information == null ? ' N/A' : formatDate(salesOrder.invoice_information.invoice_date)}
            <br />
            Invoice number : {salesOrder.invoice_information == null ? ' N/A' : salesOrder.invoice_information.invoice_number}
            <br />
            Total value : {Number(salesOrder.total_amount).toLocaleString(undefined, {minimumFractionDigits:2,maximumFractionDigits:2})}<br/>
            Delivered value : {Number(salesOrder.delivered_amount).toLocaleString(undefined, {minimumFractionDigits:2,maximumFractionDigits:2})}<br/>
            Invoice date : {salesOrder.invoice_information == null ? " N/A" :formatDate(salesOrder.invoice_information.invoice_date)}<br/>
            Salesman name : {salesOrder.salesman_first_name} {salesOrder.salesman_middle_name} {salesOrder.salesman_last_name}<br/>
            Delivery Personnel : {salesOrder.delivery_personel}<br/>
            Order Status : {(salesOrder.order_status_value === null) ? 'None': salesOrder.order_status_value} 
            
            </Typography>    

      </div>)
  }

  const orderOptionsMenu = () => {
    return(
      <Menu
      id="simple-menu"
      anchorEl={orderInfoAnchorElement}
      keepMounted
      open={Boolean(orderInfoAnchorElement)}  PaperProps={{
        elevation: 1, // Adjust the elevation as needed
      }}
      onClose={()=>{setOrderInfoAnchorElement(null)}}
      >
        <MenuItem 
            onClick={()=>{
              setSelectedSalesOrder(selectedSalesOrder)
              checkIfAlreadyDelivered(selectedSalesOrder);
             }} >
            View Delivery Information 
            </MenuItem>
      </Menu>
    )
  }

  const checkIfAlreadyDelivered = (selectedSalesOrder) => {
    const salesOrderDeliveredItems = selectedSalesOrder.salesOrderDeliveredItems;

    if (salesOrderDeliveredItems.length === 0 || salesOrderDeliveredItems === undefined) {
      setOrderInfoAnchorElement(null)
      setMessageDialogMessage("The orders have not been delivered yet.")
      setShowMessageDialog(true)
      return
    }
    
    setOrderInfoAnchorElement(null)
    setOpenOrdersInfoDialog(true)
  } 

  function messageDialog(){
      return(
        <Dialog
        fullWidth={true}
        maxWidth={'sm'}
        open={showMessageDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Message"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {messageDialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>{
              setShowMessageDialog(false)

              }} 
            color="primary" autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
      )
  }

  function searchByDropdownMenu(){
    return(
      <Menu
      id="simple-menu"
      anchorEl={searchByAnchorElement}
      keepMounted
      open={Boolean(searchByAnchorElement)}
      onClose={()=>{setSearchByAnchorElement(null)}}
      >
        <MenuItem 
            onClick={()=>{ 
            setSearchByAnchorElement(null)
            setOpenDateFilterDialog(true)}} >
            Select date filter
            </MenuItem>
      </Menu>
    )
}

function dateRangeFilterDialog(){
  return (
    <Dialog
      fullWidth={true}
      open={openDateFilterDialog}
      onClose={()=>{}}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{"Filter date"}</DialogTitle>
      <DialogContent>
        <Grid container spacing={1}>
              <Grid item xs={12}>
                  

                  <StyledEngineProvider injectFirst>
                      <ThemeProvider theme={materialTheme}>
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                              <MobileDatePicker
                              inputFormat="MMMM d, yyyy"
                              value={startingDate}
                              open={openStartingDateCalendar}
                              onChange={(date)=>{ setStartingDate(date)}}
                              onOpen={() => setOpenStartingDateCalendar(true)}
                              onClose={() => setOpenStartingDateCalendar(false)}
                              renderInput={(params) => 
                                  <TextField 
                                      {...params} 
                                      label={"Starting date"}
                                      style={{width:"99%",margin:"1%"}}
                                      InputProps={{
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <IconButton edge="end" onClick={()=>{setOpenStartingDateCalendar(true)}}>
                                                <EventIcon />
                                              </IconButton>
                                            </InputAdornment>
                                          ),
                                        }}
                                      />
                                  }
                              />
                          </LocalizationProvider>
                      </ThemeProvider>
                  </StyledEngineProvider>  

              </Grid>

              <Grid item xs={12}>
                  <StyledEngineProvider injectFirst>
                      <ThemeProvider theme={materialTheme}>
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                              <MobileDatePicker
                              inputFormat="MMMM d, yyyy"
                              value={endingDate}
                              open={openEndingDateCalendar}
                              onChange={(date)=>{ setEndingDate(date)}}
                              onOpen={() => setOpenEndingDateCalendar(true)}
                              onClose={() => setOpenEndingDateCalendar(false)}
                              renderInput={(params) => 
                                  <TextField 
                                      {...params} 
                                      label={"Ending Date"}
                                      style={{width:"99%",margin:"1%"}}
                                      InputProps={{
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <IconButton edge="end" onClick={()=>{setOpenEndingDateCalendar(true)}}>
                                                <EventIcon />
                                              </IconButton>
                                            </InputAdornment>
                                          ),
                                        }}
                                      />
                                  }
                              />
                          </LocalizationProvider>
                      </ThemeProvider>
                  </StyledEngineProvider>  

              </Grid>
        </Grid>
       
      </DialogContent>
      <DialogActions>
        <Button 
        onClick={()=>{
          setOpenDateFilterDialog(false)
          setStartingFilterDate(startingDate)
          setEndingFilterDate(endingDate)
          setLoadSalesOrder(true)
        }} 
          color="primary" 
          autoFocus>

          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
}
  

  const handleCloseBreakdown = () => {
    setOpenBreakdown(false);
  };


  function formatDate(dateString){
    try {
      return format(parseISO(dateString), 'MMMM d, yyyy')
    }catch(err){
      return ""
    }
  }

  const menuHandleClick = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const menuHandleClose = () => {
    setMenuAnchorEl(null)
  };
  
return (
  <div>
      <CssBaseline />
      <Dialog
      fullScreen
      open={openBreakdown}
      onClose={handleCloseBreakdown}
    >
      <AppBar sx={{ position: 'relative' }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleCloseBreakdown}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Order Summary Breakdown
          </Typography>
        </Toolbar>
      </AppBar>
      {isLoading ? <LinearProgress color="secondary"  style={{marginLeft:'.1rem',marginRight:'.1rem'}}/> : ''}
      <Box className={classes.paper}>
    </Box>
    </Dialog>
      <AppBar 
        position="fixed" 
        className={classes.appBar}
        aria-haspopup="true"
      >
          <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={props.handleDrawerToggle}
            className={classes.menuButton}
            size="large">
              <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap>
              For Delivery
          </Typography>
          <div className={classes.flexGrow} />
          
          </Toolbar>
      </AppBar>
      {search()}
      {isLoading ? <LinearProgress color="secondary"  style={{marginLeft:'.1rem',marginRight:'.1rem'}}/> : ''}
      <List ref={accountsElement}>
        {
            salesOrders.map((salesOrder,index)=>{ 
              
                return(
                accounts.length === index + 1
                  ?
                    <div key={salesOrder.id}>
                    <ListItem button divider style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                      {salesOrderElement(salesOrder)}
                      {orderOptionsMenu()}
                        <IconButton   
                          size="large" 
                          onClick={(event) => {
                            // Handle click
                            setSelectedSalesOrder(salesOrder);
                            setOrderInfoAnchorElement(event.currentTarget);
                          }}
                        >
                          <MoreVertIcon />
                        </IconButton>
                    </ListItem>
                    
                    </div>
                  :
                  <div key={salesOrder.id} >
                      <ListItem button divider style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>

                        {salesOrderElement(salesOrder)}
                        {orderOptionsMenu()}
                          <IconButton   
                            size="large" 
                            onClick={(event) => {
                              event.stopPropagation();
                              // Handle click
                              setSelectedSalesOrder(salesOrder);
                              setOrderInfoAnchorElement(event.currentTarget);
                            }}
                          >
                          <MoreVertIcon />
                        </IconButton>
                      </ListItem>

                  </div>
                )
            })
          
        }
        
        </List>
       <div>
       {openOrdersInfoDialog && (
        <ForDeliveriesInformation
          openOrdersInfoDialog={openOrdersInfoDialog}
          setOpenOrdersInfoDialog={setOpenOrdersInfoDialog}
          selectedSalesOrder={selectedSalesOrder}
          setSelectedSalesOrder={setSelectedSalesOrder}
        />
      )}
       </div>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={materialTheme}>
            {dateRangeFilterDialog()}
            {messageDialog()}
          </ThemeProvider>
        </StyledEngineProvider>
      
  </div>
);
}


